import { StudentDocumentsFilter } from './student-documents-filter';
import { ChangeDetectorRef, TemplateRef, ViewChild, Directive } from '@angular/core';
import { StudentDocuments } from '../../shared-components/student/student-documents.model';
import { StudentService } from '../../shared-components/student/student.service';
import { YearService } from '../../shared-components/year/year.service';
import { SharedService } from '../../shared-components/shared.service';
import { TylerMatTableDataSource } from '../../shared-components/angular-material/extended.class';
import { System } from '../../shared-components/System';
import { Student360Service } from '../student360.service';

@Directive()
export class StudentDocumentsFilteredComponent {

	// Properties
    angularMatData = new TylerMatTableDataSource();
    showFilter: boolean = false;
	filter = new StudentDocumentsFilter();
	previousFilter = new StudentDocumentsFilter();
    studentDocuments: StudentDocuments[];
	@ViewChild('filterMenu', { read: TemplateRef }) filterMenu: TemplateRef<any>;

	// Class Functions
	constructor(
		protected studentService: StudentService,
		protected yearService: YearService,
		protected sharedService: SharedService,
		protected changeDetector: ChangeDetectorRef,
		protected student360Service: Student360Service
	) { }

	get filtered() {
		if (this.student360Service.studentDocumentsFilterData != undefined) {
			this.filter = this.student360Service.studentDocumentsFilterData;
		}
		if (this.filter.createdFrom && this.filter.createdFrom.toString() == 'Invalid Date') {
			this.filter.createdFrom = undefined;
		}
		if (this.filter.createdTo && this.filter.createdTo.toString() == 'Invalid Date') {
			this.filter.createdTo = undefined;
		}
		return !System.isEqual(this.filter, new StudentDocumentsFilter());
	}

	// Methods
	showFilterClick() {
		// PRE: the filter button is pressed
        // POST: toggles the filter panel
        this.showFilter = !this.showFilter;
		Object.assign(this.previousFilter, this.filter);
	}

	clearFilter() {
		// PRE: the clear filter button is clicked
		// POST: clears out the filter and DOES NOT CLOSE THE MENU
		setTimeout(
			() => {
				Object.assign(this.filter, new StudentDocumentsFilter());
				this.applyFilter();
				this.changeDetector.detectChanges();
			},
			0
		);
	}

	closeFilter() {
        this.showFilterClick();
	}

	setFilter(filter: StudentDocumentsFilter) {
		this.filter = filter;
		this.applyFilter();
	}

	clearFilterFromFooter() {
		// PRE: the clear all filters button is clicked on the footer notification
		// POSt: clears out the filters on both the panel and the grid. Saves all changes.
		this.filter = new StudentDocumentsFilter();
		this.previousFilter = new StudentDocumentsFilter();
		this.applyFilter();
		this.angularMatData.removeAllFilters();
		this.student360Service.studentDocumentsFilterData = this.filter;
		this.changeDetector.detectChanges();
	}

	applyFilter() {
		// POST: applies the filter to the grid data
		let tableData = this.studentDocuments;

		// File Name
		if (this.filter.fileName) {
			tableData = tableData.filter(datum =>
				datum.Name.toLowerCase().includes(this.filter.fileName.toLowerCase())
			);
		}

		// Document Type
		if (this.filter.documentType) {
			tableData = tableData.filter(datum =>
				datum.DocumentType.toLowerCase().includes(this.filter.documentType.toLowerCase())
			);
		}

		// For
		if (this.filter.for) {
			tableData = tableData.filter(datum =>
				datum.DocumentFor.toLowerCase().includes(this.filter.for.toLowerCase())
			);
		}

		// File Type
		if (this.filter.fileType) {
			tableData = tableData.filter(datum =>
				datum.FileType.toLowerCase().includes(this.filter.fileType.toLowerCase())
			);
		}

		// Description
		if (this.filter.description) {
			tableData = tableData.filter(datum =>
				datum.Notes.toLowerCase().includes(this.filter.description.toLowerCase())
			);
		}

		// Created From
		if (this.filter.createdFrom && this.filter.createdFrom.toString() != 'Invalid Date') {
			tableData = tableData.filter(datum =>
				datum.CreatedOn > this.filter.createdFrom
			);
		}

		// Created To
		if (this.filter.createdTo && this.filter.createdTo.toString() != 'Invalid Date') {
			tableData = tableData.filter(datum =>
				datum.CreatedOn < this.filter.createdTo
			);
		}

		// Added By
		if (this.filter.addedBy) {
			tableData = tableData.filter(datum =>
				datum.CreatedBy.toLowerCase().includes(this.filter.addedBy.toLowerCase())
			);
		}

		// Setting the table data
		this.angularMatData.data = tableData;
	}
}
